import { useState } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';
import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { TimeRange } from '../types/instance';

export const useBufferedRanges = () => {
    const instance = usePlayerInstance();
    const [bufferedRanges, setBufferedRanges] = useState<ReadonlyArray<TimeRange> | undefined>(
        () => instance?.bufferedRanges
    );

    useInstanceEffect((instance) => instance.onBufferedRangesChange(setBufferedRanges));

    return bufferedRanges;
};
